import { render, staticRenderFns } from "./FollowersView.vue?vue&type=template&id=399c7f7a&scoped=true&"
import script from "./FollowersView.vue?vue&type=script&lang=ts&"
export * from "./FollowersView.vue?vue&type=script&lang=ts&"
import style0 from "./FollowersView.vue?vue&type=style&index=0&id=399c7f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c7f7a",
  null
  
)

export default component.exports